/**
 * deployment-tabs.ts — the Deployments feature's section tabs.
 *
 * Single source of truth for the per-project sub-header. The feature owns
 * this list: `DeploymentsHeader.svelte` renders it, and `routes.ts` derives
 * its route-id set + nav-highlight derivation from it — so there's exactly
 * one place to add/rename/reorder a section.
 *
 * Note: route ids stay stable contracts. The "releases" tab is the deploy
 * pipeline/history view (the old "deployments" sub-tab, renamed to
 * disambiguate it from the rail's top-level Deployments product).
 */

/** The section tabs, in display order. */
export const DEPLOYMENT_TABS = [
  { id: "overview",    label: "Overview" },
  { id: "compose",     label: "Compose" },
  { id: "releases",    label: "Releases" },
  { id: "code",        label: "Code" },
  { id: "domain",      label: "Domain" },
  { id: "storage",     label: "Storage" },
  { id: "database",    label: "Database" },
  { id: "performance", label: "Performance" },
  { id: "logs",        label: "Logs" },
  { id: "activity",    label: "Activity" },
  { id: "cost",        label: "Cost" },
  { id: "security",    label: "Security" },
] as const;

/** The valid section ids (for routing + active-tab derivation). */
export const DEPLOYMENT_TAB_IDS = DEPLOYMENT_TABS.map((t) => t.id);

export type DeploymentTabId = (typeof DEPLOYMENT_TABS)[number]["id"];
